module.exports = __webpack_public_path__ + "static/media/CIM_logo.a97d77a9.png";